import * as remoteAction from "../remoteAction";

interface ResendShare {
  shareId: string;
  recipient: string;
}

export type ResendShareActionSuccess = remoteAction.MerchantRemoteResponse<
  "RESEND_SHARE_SUCCESS",
  any
>;
export type ResendShareActionFailure = remoteAction.MerchantRemoteResponse<
  "RESEND_SHARE_FAILURE",
  any
>;
export type ResendShareActionRequest = remoteAction.MerchantRemoteResponse<
  "RESEND_SHARE_REQUEST",
  any
>;

export interface ResendShareAction extends remoteAction.PostRemoteRequest {
  types: {
    request: "RESEND_SHARE_REQUEST";
    success: "RESEND_SHARE_SUCCESS";
    failure: "RESEND_SHARE_FAILURE";
  };
}

export function resendShare(data: ResendShare): ResendShareAction {
  return {
    data,
    method: "POST",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "RESEND_SHARE_FAILURE",
      request: "RESEND_SHARE_REQUEST",
      success: "RESEND_SHARE_SUCCESS",
    },
    https: true,
    url: `/share/shares`,
  };
}
